// Mirror the shared domain limits for immediate feedback; the server validates every write again.
export const communicationLimits = {
  maximumMessageLength: 4_000,
  maximumAttachments: 10,
  maximumAttachmentSizeBytes: 200 * 1024 * 1024,
  maximumIdsPerRequest: 100,
  notificationPageSize: 30,
  notificationPreviewSize: 5
} as const;

export const communicationHubEvents = {
  ready: 'CommunicationReady',
  changed: 'CommunicationChanged'
} as const;

export const communicationTiming = {
  requestTimeoutMs: 15_000,
  ticketRefreshWindowMs: 30_000,
  reconnectDelayMs: 5_000,
  automaticReconnectDelaysMs: [0, 2_000, 5_000, 10_000, 30_000]
} as const;

export const chatDisplay = {
  bottomScrollThresholdPixels: 100,
  characterCounterThreshold: Math.floor(communicationLimits.maximumMessageLength * 0.9)
} as const;
